module.exports = __webpack_public_path__ + "static/img/Dropdown_Icon.40441210.png";